module.exports = __webpack_public_path__ + "img/4.99115533.png";